export default __webpack_public_path__ + "727b21cd049446bc1bc43737f7c5ef78.webp";